/**
 * iOS keeps a circuit selected while its details sheet is being dismissed.
 * Its marker must therefore follow the explicit selected prop, not the
 * drawer animation state. Android retains its existing redraw workaround.
 */
export const shouldResetSelectedPinWhenDrawerCloses = (
  platform: string,
  drawerIsClosed: boolean,
): boolean => platform !== 'ios' && drawerIsClosed;

export const resolveMapSelectedId = (
  platform: string,
  isListView: boolean,
  activeBranchMarker?: string,
  selectedBranchId?: string,
): string | undefined => {
  if (platform === 'web' && isListView) {
    return undefined;
  }

  // The iOS bottom sheet may clear its Redux selection while the circuit
  // preview intentionally remains active. In that state branchMarker is the
  // authoritative selection and keeps the main marker yellow.
  return platform === 'ios' ? activeBranchMarker ?? selectedBranchId : selectedBranchId;
};
